import uniq from "lodash-es/uniq";
import * as toastr from "toastr";
import { ICalendarEvent } from "motw_core/Calendar/ICalendarEvent";

export function ShowWarningForExpiredEvents(eventData: ICalendarEvent[]) {
    const expiredEventNames = eventData
        .filter((calendarEvent) => calendarEvent.isExpired === true)
        .map((calendarEvent) => calendarEvent.name);

    const uniqueEventNames = uniq(expiredEventNames);

    if (uniqueEventNames.length === 0) {
        return;
    }

    const uniqueEventNamesJoined = uniqueEventNames.join(`, `);

    toastr.warning(`Found expiring calendar events: ${uniqueEventNamesJoined}`);
}
